import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeObjCPV } from '../models/TypeObjCPV';
import { TypeCPVClass } from '../models/TypeCPVClass';

@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeObjCPV';
  @Input() parentForm: FormGroup;
  @Input() typeObjCPV: TypeObjCPV;

  constructor() {
  }

  public ngOnInit() {
  }

  public addtypeCPVClass() {
    this.typeObjCPV.objetComplementaire.push(new TypeCPVClass());
  }

  public removetypeCPVClass(i) {
    this.typeObjCPV.objetComplementaire.splice(i, 1);
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
